/**
 * Model for the whole voyage.
 *
 *
 */
var VRC = VRC || {};

VRC.Voyage = function () {
	var _voyageId, _missionType, _remarks,
		_toPort, _startFuel, _startLng,
		_fromPort, _endFuel, _endLng;
	var _fromDateTime;
	var _toDateTime;
	var _seqNo;

	var init = function () {
	};

	var resetValues = function () {
		parse({});
	};

	var startNewVoyage = function (params) {
		params = params || {};
		resetValues();
		setVoyageId(params.voyage_id);
		setMissionType(params.mission_type);

		save();
	};

	var setVoyageId = function (voyageId) {
		_voyageId = voyageId;
	};

	var getVoyageId = function () {
		return _voyageId;
	};

	var getMissionType = function () {
		return _missionType || 'supply';
	};

	var setMissionType = function (voyageType) {
		_missionType = voyageType;
	};

	var getRemarks = function () {
		return _remarks;
	};

	var setRemarks = function (remarks) {
		_remarks = remarks;
	};

	var getFromPort = function () {
		return _fromPort;
	};

	var setFromPort = function (fromPort) {
		_fromPort = fromPort;
	};

	var getToPort = function () {
		return _toPort;
	};

	var setToPort = function (toPort) {
		_toPort = toPort;
	};

	var getToDateTime = function () {
		return _toDateTime;
	};

	var setToDateTime = function (toDateTime) {
		_toDateTime = toDateTime;
	};

	var getStartFuel = function () {
		return _startFuel;
	};

	var setStartFuel = function (startFuel) {
		_startFuel = startFuel ? parseFloat(startFuel) : undefined;
	};

	var getEndFuel = function () {
		return _endFuel;
	};

	var setEndFuel = function (endFuel) {
		_endFuel = endFuel ? parseFloat(endFuel) : undefined;

	};
	var getStartLng = function () {
		return _startLng;
	};

	var setStartLng = function (startLng) {
		_startLng = startLng ? parseFloat(startLng) : undefined;
	};
	var getEndLng = function () {
		return _endLng;
	};

	var setEndLng = function (endLng) {
		_endLng = endLng ? parseFloat(endLng) : undefined;
	};

	var calcFromDate = function () {
		var firstEvent = VRC.VoyageLogEntryManager.getFirst();
		if (firstEvent) {
			setFromDateTime(firstEvent.getDateTime());
		}
	};

	var getSeqNo = function () {
		return _seqNo;
	};

	var setSeqNo = function (seqNo) {
		_seqNo = seqNo;
	};

	var getFromDateTime = function () {
		return _fromDateTime;
	};

	var setFromDateTime = function (fromDateTime) {
		_fromDateTime = fromDateTime;
	};

	/*
	 * Saves all log entries to local storage
	 */
	var save = function () {
		var l_data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA']);

		l_data.current_voyage = toJson();

		g_localsave_object.SetLocalStorageItem(G_LS_NAMES['MAIN_VESSEL_DATA'], l_data);
	};

	var parse = function (json) {
		setVoyageId(json.voyage_id);
		setMissionType(json.mission_type);
		setRemarks(json.remarks);
		setToPort(json.to_port_id);
		setStartFuel(json.start_fuel);
		setStartLng(json.start_lng);
		setSeqNo(json.seq_no);
		calcFromDate();
		setFromDateTime(json.from_dateTime || json.from_date);
		setToDateTime(json.to_dateTime || json.to_date);

		setEndFuel(json.end_fuel);
		setEndLng(json.end_lng);

	};

	var toJson = function () {

		return {
			voyage_id: getVoyageId(),
			mission_type: getMissionType(),
			remarks: getRemarks(),
			to_dateTime: getToDateTime(),
			to_port_id: getToPort(),
			start_fuel: getStartFuel(),
			start_lng: getStartLng(),
			from_dateTime: getFromDateTime(),
			from_port: getFromPort(),
			end_fuel: getEndFuel(),
			end_lng: getEndLng(),
			seq_no: getSeqNo()
		};
	};

	/*
	 * Loads all log entries from localstorage
	 */
	var load = function () {
		var data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);

		if (data && data.current_voyage) {
			parse(data.current_voyage);
			calcFromDate();
		}

	};

	var clear = function () {
		var data = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA);

		if (data && data.current_voyage) {
			delete data.current_voyage;
		}
		g_localsave_object.SetLocalStorageItem(G_LS_NAMES.MAIN_VESSEL_DATA, data);
	};

	/*
	 * Callback function for parsing log data from database
	 |      */
	var parseVoyageData = function (p_owner, p_data) {

		if (p_data === undefined || p_data == null) {
			return;
		}
		else if (p_data.current_voyage === undefined) {
			VRC.ErrorHandleService.showMessage('No voyage data found. Need to start a new voyage', G_MSG_TYPE_WARNING);
			p_owner = null;
			return;
		}

		//Store last mission type
		var last_mission_type = p_owner.getMissionType();

		parse(p_data.current_voyage);

		if (!p_owner.getMissionType()) {
			p_owner.setMissionType('supply');
		}

		p_owner.calcFromDate();
		p_owner.save();

		//If mission_type has changed
		if (last_mission_type !== p_owner.getMissionType()) {
			VRC.CurrentVoyage.init();
		}
		VRC.CurrentVoyage.onVoyageLogChange();

	};
	/*
	 * Fetches log entries from database
	 */
	var fetch = function () {
		var _this = this;
		var deferred = $.Deferred();

		var onSuccess = function (object, data) {
			_this.parseVoyageData(object, data);
			deferred.resolve(object, data);
		};

		g_remote_object.FetchDataFromServer(_this, onSuccess, 'voyage', '');

		return deferred.promise();
	};

	var endAndStartVoyage = function () {
		save();
		var voyage = toJson();
		if (moment(getFromDateTime(), g_timeStampFormat, true).isValid()) {
			var onSuccess = function () {
				FetchData();
				VRC.ErrorHandleService.showMessage('Voyage successfully submitted and new voyage started', G_MSG_TYPE_SUCCESS);
			};
			g_remote_object.FetchDataFromServer(this, onSuccess, 'new_voyage', voyage);
		}
		else {
			VRC.ErrorHandleService.showMessage('Start date is not a valid date. Please make sure that all event logs are valid dates', G_MSG_TYPE_ERROR);
		}

	};

	var endVoyage = function () {

		if (moment(getFromDateTime(), g_timeStampFormat, true).isValid()) {
			VRC.CurrentVoyage.endVoyage();
		}
		else {
			VRC.ErrorHandleService.showMessage('Start date is not a valid date. Please make sure that all event logs are valid dates', G_MSG_TYPE_ERROR);
		}

	};

	var getWarnings = function () {
		var _this = this;
		VRC.LoadingModal.show();
		var callback = function (self, data) {
			VRC.LoadingModal.hide();
			var warningWrapper = data.voyage_alerts;
			if ($.isEmptyObject(warningWrapper)) {

				var html = '<p>You will now end the current voyage. A new voyage will be started. Are you sure?</p>';
				if (data.next_voyage_date) {
					html = '<p>You will now end the current voyage. An open voyage at ' + data.next_voyage_date + ' will be the new current voyage. Are you sure?</p>';
				}

				VRC.PopupManager.show(html, {
					title: 'Voyage validations',
					buttons: {
						"Cancel": function () {
							$(this).dialog("close");
						},
						"End voyage": function () {
							self.endVoyage();
							$(this).dialog("close");
						},
						"End and Start voyage": function () {
							self.endAndStartVoyage();
							$(this).dialog("close");
						}
					}
				});

			}
			else {
				var warnings = [];

				$.each(warningWrapper, function (key, warningsSubSet) {

					warnings = warnings.concat(warningsSubSet);
				});

				var html = WELL.Handlebars.VRC.show_warnings({warnings: warnings});

				VRC.PopupManager.show(html, {
					title: 'Voyage validations',
					buttons: {
						"Cancel": function () {
							$(this).dialog("close");
						},

						"End voyage": function () {
							self.endVoyage();
							$(this).dialog("close");
						},
						"End and Start voyage": function () {
							self.endAndStartVoyage();
							$(this).dialog("close");
						}
					}
				});
			}
		};
		this.save();
		g_voyage_planning.SaveLogEntries();
		g_remote_object.SubmitAllData('all',
			function (data) {
				g_remote_object.FetchDataFromServer(_this, callback, 'warnings', '');
			}, function () {
				VRC.LoadingModal.hide()
			}
		);
	};

	init();

	return {
		getVoyageId: getVoyageId,
		setVoyageId: setVoyageId,
		getMissionType: getMissionType,
		setMissionType: setMissionType,
		getRemarks: getRemarks,
		setRemarks: setRemarks,

		getToPort: getToPort,
		setToPort: setToPort,
		getStartFuel: getStartFuel,
		setStartFuel: setStartFuel,
		getStartLng: getStartLng,
		setStartLng: setStartLng,
		calcFromDate: calcFromDate,

		getFromPort: getFromPort,
		setFromPort: setFromPort,
		getEndFuel: getEndFuel,
		setEndFuel: setEndFuel,
		getEndLng: getEndLng,
		setEndLng: setEndLng,

		getSeqNo: getSeqNo,
		setSeqNo: setSeqNo,
		getFromDateTime: getFromDateTime,
		setToDateTime: setToDateTime,
		getWarnings: getWarnings,
		endVoyage: endVoyage,
		endAndStartVoyage: endAndStartVoyage,
		fetch: fetch,
		parseVoyageData: parseVoyageData,
		load: load,
		save: save,
		startNewVoyage: startNewVoyage,
		resetValues: resetValues,
		toJson: toJson,
		parse: parse,

		clear: clear
	}

};